import { Filter } from '@iot-platform/models/common';
import { I4BGridFilterOptions } from '@iot-platform/models/grid-engine';
import { FilterCategoryV2, FilterFieldV2 } from '../models';
import { getFieldFromConfig } from './filter-config.helper';

/**
 * Migrates old FavoriteView filters to new format
 *
 * Old format example:
 * {
 *   criteriaKey: "siteType",
 *   criteriaLabel: "FILTER_ENGINE.CRITERIA_FULL_LABEL.SITE_TYPE",
 *   label: "SITES.CARD.TYPES.production_site",
 *   value: "production_site"
 * }
 *
 * New format example:
 * {
 *   criteriaKey: "siteType",
 *   criteriaLabel: "FILTER_ENGINE.CRITERIA_FULL_LABEL.SITE_TYPE",
 *   criteriaOperator: "equals",
 *   label: "SITES.CARD.TYPES.production_site",
 *   value: "production_site",
 *   valueDisplay: "SITES.CARD.TYPES.production_site"
 * }
 *
 * @param filters - Array of filters from FavoriteView
 * @param categories - Array of FilterFieldV2 or FilterCategoryV2
 * @returns Migrated filters with criteriaOperator and valueDisplay properties
 */
export function migrateFilters(filters: Filter[], categories: (FilterFieldV2 | FilterCategoryV2)[]): Filter[] {
  return filters.map((filter: Filter) => {
    const migratedFilter = { ...filter };

    // Add criteriaOperator if missing (default to 'equals')
    if (!migratedFilter.criteriaOperator) {
      const field = getFieldFromConfig(migratedFilter.criteriaKey as string, categories);
      let defaultOperator = I4BGridFilterOptions.EQUALS;
      if (field) {
        defaultOperator = (field as FilterFieldV2).defaultOperator as I4BGridFilterOptions;
      }
      migratedFilter.criteriaOperator = defaultOperator;
    }

    // Add valueDisplay if missing (use label or value as fallback)
    if (!migratedFilter.valueDisplay) {
      migratedFilter.valueDisplay = filter.label || filter.value;
    }

    return migratedFilter;
  });
}
